import React, { forwardRef } from 'react';
import styled from '@grebban/style-system-react';
import asArray from '@grebban/array-utils/asArray';
import PropTypes from 'prop-types';

const StyledImageBackground = styled('div')``;

const ImageBackground = forwardRef(({ src, ...rest }, ref) => <StyledImageBackground ref={ref} backgroundImage={asArray(src).map(source => `url(${source});`)} {...rest} />);

ImageBackground.propTypes = {
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

ImageBackground.defaultProps = {
    src: [],
};

export default ImageBackground;
